import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id C91D9DCD-5ADA-4D48-857C-39D38CD37A6B
 * name shape-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shape-plus.svg
 * tags
 * - Shape 
 */
export const ShapePlusIcon = createSvgIcon(<><path d="M2,2H11V11H2V2M17.5,2C20,2 22,4 22,6.5C22,9 20,11 17.5,11C15,11 13,9 13,6.5C13,4 15,2 17.5,2M6.5,14L11,22H2L6.5,14M19,17H22V19H19V22H17V19H14V17H17V14H19V17Z" /></>, 'ShapePlusIcon');
export default ShapePlusIcon